import { render } from "./FeedbackInterval.vue?vue&type=template&id=5472b7f0&scoped=true&lang=pug"
import script from "./FeedbackInterval.vue?vue&type=script&lang=js"
export * from "./FeedbackInterval.vue?vue&type=script&lang=js"

import "./FeedbackInterval.vue?vue&type=style&index=0&id=5472b7f0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5472b7f0"]])

export default __exports__